/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  CREATE_PENDING_CITIZEN_ACCOUNT,
  EMAIL_PASSWORD_RESET,
  IS_EMAIL_VERIFIED,
  ACTIVATE_EMAIL,
  POST_ACES_ACTIVATION_LINK_EMAIL,
  POST_ACES_ACTIVATE_CITIZEN_ACCOUNT,
  POST_ACES_RESEND_ACTIVATION_LINK_EMAIL,
  POST_ACES_SEND_FORGOT_USERNAME_EMAIL,
  POST_ACES_ACCOUNT_UNLOCK,
  POST_ACES_CHECK_ACCOUNT_ENABLE,
  POST_ACES_SEND_ACCOUNT_UNLOCK_EMAIL,
} from './actionTypes';

/**
 * Updates the details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const createPendingCitizenAccountReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, CREATE_PENDING_CITIZEN_ACCOUNT);

/**
 * Updates the indicator of creation of details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingCreatePendingCitizenAccountReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, CREATE_PENDING_CITIZEN_ACCOUNT);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const createPendingCitizenAccountErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, CREATE_PENDING_CITIZEN_ACCOUNT);

/**
 * Updates the details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const emailPasswordResetReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, EMAIL_PASSWORD_RESET);

/**
 * Updates the indicator of creation of details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingEmailPasswordResetReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, EMAIL_PASSWORD_RESET);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const emailPasswordResetErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, EMAIL_PASSWORD_RESET);

/**
 * Updates the details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isEmailVerifiedReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, IS_EMAIL_VERIFIED);

/**
 * Updates the indicator of creation of details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingIsEmailVerifiedReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, IS_EMAIL_VERIFIED);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const isEmailVerifiedErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, IS_EMAIL_VERIFIED);

/**
 * Updates the details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const activateEmailReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, ACTIVATE_EMAIL);

/**
 * Updates the indicator of creation of details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingActivateEmailReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, ACTIVATE_EMAIL);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const activateEmailErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, ACTIVATE_EMAIL);

/**
 * Updates the details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesActivationLinkEmailReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACES_ACTIVATION_LINK_EMAIL);

/**
 * Updates the indicator of creation of details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesActivationLinkEmailReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACES_ACTIVATION_LINK_EMAIL);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesActivationLinkEmailErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACES_ACTIVATION_LINK_EMAIL);

/**
 * Updates the details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesActivateCitizenAccountReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACES_ACTIVATE_CITIZEN_ACCOUNT);

/**
 * Updates the indicator of creation of details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesActivateCitizenAccountReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACES_ACTIVATE_CITIZEN_ACCOUNT);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesActivateCitizenAccountErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACES_ACTIVATE_CITIZEN_ACCOUNT);

/**
 * Updates the details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesResendActivationLinkEmailReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACES_RESEND_ACTIVATION_LINK_EMAIL);

/**
 * Updates the indicator of creation of details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesResendActivationLinkEmailReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACES_RESEND_ACTIVATION_LINK_EMAIL);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesResendActivationLinkEmailErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACES_RESEND_ACTIVATION_LINK_EMAIL);

/**
 * Updates the details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesSendForgotUsernameEmailReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACES_SEND_FORGOT_USERNAME_EMAIL);

/**
 * Updates the indicator of creation of details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesSendForgotUsernameEmailReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACES_SEND_FORGOT_USERNAME_EMAIL);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesSendForgotUsernameEmailErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACES_SEND_FORGOT_USERNAME_EMAIL);

/**
 * Updates the details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesAccountUnlockReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACES_ACCOUNT_UNLOCK);

/**
 * Updates the indicator of creation of details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesAccountUnlockReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACES_ACCOUNT_UNLOCK);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesAccountUnlockErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACES_ACCOUNT_UNLOCK);

/**
 * Updates the details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesCheckAccountEnableReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACES_CHECK_ACCOUNT_ENABLE);

/**
 * Updates the indicator of creation of details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesCheckAccountEnableReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACES_CHECK_ACCOUNT_ENABLE);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesCheckAccountEnableErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACES_CHECK_ACCOUNT_ENABLE);

/**
 * Updates the details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesSendAccountUnlockEmailReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACES_SEND_ACCOUNT_UNLOCK_EMAIL);

/**
 * Updates the indicator of creation of details in the 'ACESUserRegistration' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesSendAccountUnlockEmailReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACES_SEND_ACCOUNT_UNLOCK_EMAIL);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesSendAccountUnlockEmailErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACES_SEND_ACCOUNT_UNLOCK_EMAIL);

const reducers = combineReducers({
  createPendingCitizenAccount: createPendingCitizenAccountReducer,

  isFetchingCreatePendingCitizenAccount: isFetchingCreatePendingCitizenAccountReducer,
  createPendingCitizenAccountError: createPendingCitizenAccountErrorReducer,

  emailPasswordReset: emailPasswordResetReducer,

  isFetchingEmailPasswordReset: isFetchingEmailPasswordResetReducer,
  emailPasswordResetError: emailPasswordResetErrorReducer,

  isEmailVerified: isEmailVerifiedReducer,

  isFetchingIsEmailVerified: isFetchingIsEmailVerifiedReducer,
  isEmailVerifiedError: isEmailVerifiedErrorReducer,

  activateEmail: activateEmailReducer,

  isFetchingActivateEmail: isFetchingActivateEmailReducer,
  activateEmailError: activateEmailErrorReducer,

  postAcesActivationLinkEmail: postAcesActivationLinkEmailReducer,

  isFetchingPostAcesActivationLinkEmail: isFetchingPostAcesActivationLinkEmailReducer,
  postAcesActivationLinkEmailError: postAcesActivationLinkEmailErrorReducer,

  postAcesActivateCitizenAccount: postAcesActivateCitizenAccountReducer,

  isFetchingPostAcesActivateCitizenAccount: isFetchingPostAcesActivateCitizenAccountReducer,
  postAcesActivateCitizenAccountError: postAcesActivateCitizenAccountErrorReducer,

  postAcesResendActivationLinkEmail: postAcesResendActivationLinkEmailReducer,

  isFetchingPostAcesResendActivationLinkEmail: isFetchingPostAcesResendActivationLinkEmailReducer,
  postAcesResendActivationLinkEmailError: postAcesResendActivationLinkEmailErrorReducer,

  postAcesSendForgotUsernameEmail: postAcesSendForgotUsernameEmailReducer,

  isFetchingPostAcesSendForgotUsernameEmail: isFetchingPostAcesSendForgotUsernameEmailReducer,
  postAcesSendForgotUsernameEmailError: postAcesSendForgotUsernameEmailErrorReducer,

  postAcesAccountUnlock: postAcesAccountUnlockReducer,

  isFetchingPostAcesAccountUnlock: isFetchingPostAcesAccountUnlockReducer,
  postAcesAccountUnlockError: postAcesAccountUnlockErrorReducer,

  postAcesCheckAccountEnable: postAcesCheckAccountEnableReducer,

  isFetchingPostAcesCheckAccountEnable: isFetchingPostAcesCheckAccountEnableReducer,
  postAcesCheckAccountEnableError: postAcesCheckAccountEnableErrorReducer,

  postAcesSendAccountUnlockEmail: postAcesSendAccountUnlockEmailReducer,

  isFetchingPostAcesSendAccountUnlockEmail: isFetchingPostAcesSendAccountUnlockEmailReducer,
  postAcesSendAccountUnlockEmailError: postAcesSendAccountUnlockEmailErrorReducer,
});

export default { reducers };
